import type { CharacterDefinition, CharacterId } from '@/engine/types'

const avatar = (id: string) => `/assets/avatars/${id}.webp`

// 角色表只绑定已确认昵称、剧情职责和资源；头像外观不作为现实身份或性格证据。
export const characters: Record<CharacterId, CharacterDefinition> = {
  narrator: { id: 'narrator', name: '旁白', color: '#c5bfd8', description: '有限视角旁白' },
  system: { id: 'system', name: '系统', color: '#7ad4ff', description: '游戏与群聊系统通知' },
  player: { id: 'player', name: '你', color: '#e8bc78', description: '第一次进入4945区的新玩家' },
  mentor: {
    id: 'mentor',
    name: '老朋友',
    avatar: avatar('mentor'),
    color: '#7ad4ff',
    description: '懂系统、不懂新区人心的老玩家朋友',
  },
  qifu: {
    id: 'qifu',
    name: '祈福',
    organization: 'org1',
    role: '首领',
    avatar: avatar('qifu'),
    color: '#b49aff',
    romanceable: true,
    description: '一组首领（群内别名风吹雪），8月1日离开首领位置',
  },
  bottle: {
    id: 'bottle',
    name: '顶级奶瓶',
    organization: 'org1',
    role: '高层',
    avatar: avatar('bottle'),
    color: '#e8bc78',
    description: '把口号变成出勤表的一组执行者',
  },
  shana: {
    id: 'shana',
    name: '灼眼の夏娜',
    shortName: '夏娜',
    organization: 'org2',
    role: '首领/核心顾问',
    avatar: avatar('shana'),
    color: '#f39ac7',
    romanceable: true,
    description: 'YouRen，即二组首领夏娜；克制但会在现实压力下失去余裕',
  },
  chenyi: {
    id: 'chenyi',
    name: '辰逸',
    organization: 'org2',
    role: '初期高层',
    avatar: avatar('chenyi'),
    color: '#f5c65e',
    romanceable: true,
    description: '把没有回应理解为权威受损的冲突导火索',
  },
  an: {
    id: 'an',
    name: '岸',
    organization: 'org2',
    role: '初期高层',
    avatar: avatar('an'),
    color: '#b6b0c7',
    description: '只想卸下管理职责的二组高层',
  },
  shi: {
    id: 'shi',
    name: '时',
    organization: 'org2',
    role: '高层候选',
    avatar: avatar('shi'),
    color: '#a5d9ff',
    description: '7月19日从五组加入二组的跨组织人才',
  },
  daigu: {
    id: 'daigu',
    name: '大古',
    organization: 'org2',
    role: '成员',
    avatar: avatar('daigu'),
    color: '#83c8ff',
    description: '从普通成员中被提拔，8月9日离开二组并进入虚妄月华',
  },
  xilufei: {
    id: 'xilufei',
    name: '希露菲',
    organization: 'org2',
    role: '成员',
    avatar: avatar('xilufei'),
    color: '#83dbb9',
    romanceable: true,
    description: '从老区来新区找乐子、擅长把权限变成火花的人',
  },
  saoji: {
    id: 'saoji',
    name: '我是骚鸡',
    organization: 'org2',
    role: '成员',
    avatar: avatar('saoji'),
    color: '#ef9c7e',
    description: '被一组排斥后辗转来到二组的成员',
  },
  swordheart: {
    id: 'swordheart',
    name: '剑斩凡人心',
    organization: 'org2',
    role: '精英',
    avatar: avatar('swordheart'),
    color: '#9bb8ff',
    romanceable: true,
    description: '重视活动出勤的稳定战力核心',
  },
  sixin: {
    id: 'sixin',
    name: '死辛',
    organization: 'org2',
    role: '成员',
    avatar: avatar('sixin'),
    color: '#a6d6c5',
    description: '忠于可持续规则而不是群聊口号的普通成员',
  },
  heartbeat: {
    id: 'heartbeat',
    name: '心跳成瘾',
    organization: 'org3',
    role: '原三组首领/后任一组首领',
    avatar: avatar('heartbeat'),
    color: '#ff8eac',
    romanceable: true,
    description: '把人员流动看成扩张机会，8月1日接任云山乱清雪首领',
  },
  truth: {
    id: 'truth',
    name: '真理',
    organization: 'org3',
    role: '高层',
    avatar: avatar('truth'),
    color: '#99e2ff',
    description: '相信证据，也知道证据需要组织解释',
  },
  oguri: {
    id: 'oguri',
    name: 'OguriC',
    organization: 'org3',
    role: '后期高层',
    avatar: avatar('oguri'),
    color: '#d4a7ff',
    description: '从五组进入三组、用执行兑现承诺的人',
  },
  yanqiu: {
    id: 'yanqiu',
    name: '砚秋水',
    organization: 'org4',
    role: '首领/制度顾问',
    avatar: avatar('yanqiu'),
    color: '#8ad8ff',
    romanceable: true,
    description: '四组初期首领，后来因分配危机退出',
  },
  huayue: {
    id: 'huayue',
    name: '华月乌大王',
    organization: 'org4',
    role: '高层/继任首领',
    avatar: avatar('huayue'),
    color: '#e7af68',
    romanceable: true,
    description: '危机后接过四组的人',
  },
  xuanmo: {
    id: 'xuanmo',
    name: '玄末之缘',
    organization: 'org4',
    role: '高层',
    avatar: avatar('xuanmo'),
    color: '#ca9aff',
    description: '四组反二组强硬派',
  },
  jiangjinjiu: {
    id: 'jiangjinjiu',
    name: '将进酒',
    organization: 'org4',
    role: '初期高层',
    avatar: avatar('jiangjinjiu'),
    color: '#c4d7ff',
    description: '替二组说话后从四组流向三组的温和派',
  },
  takemehand: {
    id: 'takemehand',
    name: 'takemehand',
    organization: 'org4',
    role: '成员',
    avatar: avatar('takemehand'),
    color: '#f5a8d0',
    romanceable: true,
    description: '两次权限争议的直接当事人',
  },
  wenxian: {
    id: 'wenxian',
    name: '温陷',
    organization: 'org5',
    role: '首领/保守派核心',
    avatar: avatar('wenxian'),
    color: '#d6a6ff',
    romanceable: true,
    description: '在名字、成员与资源之间犹豫的五组核心，8月9日前后退游',
  },
  gaobai: {
    id: 'gaobai',
    name: '告白',
    organization: 'org5',
    role: '主战派高层',
    avatar: avatar('gaobai'),
    color: '#ff8399',
    description: '推动火2战书并连续转组的主战者',
  },
  jianwen: {
    id: 'jianwen',
    name: '剑问白玉京',
    organization: 'org5',
    role: '成员/后期高层',
    avatar: avatar('jianwen'),
    color: '#e2c681',
    description: '在核心离开后把五组继续维持下去的人',
  },
  yyt: {
    id: 'yyt',
    name: 'yyT',
    organization: 'org6',
    role: '首领/激进派',
    avatar: avatar('yyt'),
    color: '#ff9b79',
    romanceable: true,
    description: '第六组织的公开冲突能力与内部权力压力',
  },
  emperor: {
    id: 'emperor',
    name: '皇帝',
    organization: 'org6',
    role: '高层',
    avatar: avatar('emperor'),
    color: '#e8bc78',
    description: '六组核心成员',
  },
  avucii: {
    id: 'avucii',
    name: 'AVUCII',
    organization: 'org6',
    role: '高层/继任首领',
    avatar: avatar('avucii'),
    color: '#7fdac0',
    romanceable: true,
    description: '擅长名单、交接与合并善后的六组执行者',
  },
  haogeju: {
    id: 'haogeju',
    name: '好歌剧',
    organization: 'org2',
    role: '成员',
    avatar: avatar('haogeju'),
    color: '#cbb7e9',
    description: '二组普通成员群像',
  },
  lan: {
    id: 'lan',
    name: '蓝',
    organization: 'org2',
    role: '成员',
    avatar: avatar('lan'),
    color: '#ef6d6d',
    description: '把打卡和群聊都当成生活小剧场的二组成员',
  },
  xingqing: {
    id: 'xingqing',
    name: '星晴',
    organization: 'org6',
    role: '成员',
    avatar: avatar('xingqing'),
    color: '#d8a6c9',
    description: '总把猫抱进群聊，却能在六组最乱时记住每个人的去向',
  },
  crowd: { id: 'crowd', name: '群成员', color: '#c5bfd8', description: '公共群聊中的合成群像' },
}

// 攻略候选清单是剧情判定与收藏计数的共同数据源，新增角色只需在这里登记一次。
export const romanceCandidates = (
  [
    'shana', 'qifu', 'chenyi', 'swordheart', 'heartbeat', 'yanqiu', 'huayue', 'wenxian',
    'takemehand', 'xilufei', 'yyt', 'avucii',
  ] satisfies CharacterId[]
)
